<template>
	<div>
		<md-card-content>
			<div class="md-layout">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Nom :</span>
					{{ site.name }}
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Archivé :</span>
					<span :class="site.is_archived ? 'text-success' : 'text-danger'">
						{{ isActive(site.is_archived) }}
					</span>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Code EBP :</span>
					{{ site.code_ebp }}
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Accès Espace Client :</span>
					<span :class="site.is_client_area_available ? 'text-success' : 'text-danger'">
						{{ isActive(site.is_client_area_available) }}
					</span>
				</div>
			</div>
			<div class="md-layout mt-4" v-if="site.is_client_area_available">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Identifiant :</span>
					{{ site.username ? site.username : 'Ø' }}
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Mot de passe :</span>
					{{ site.username ? site.password : 'Ø' }}
				</div>
			</div>
			<div class="md-layout mt-4">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Groupements :</span>
						<span :class="site.is_group_active ? 'text-success' : 'text-danger'">
						{{ isActive(site.is_group_active) }}
					</span>
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Envoie Rapport Direct :</span>
						<span :class="site.is_report_direct ? 'text-success' : 'text-danger'">
						{{ isActive(site.is_report_direct) }}
					</span>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Appatage Non Permanent :</span>
						<span :class="site.is_baiting_unpermanent ? 'text-success' : 'text-danger'">
						{{ isActive(site.is_baiting_unpermanent) }}
					</span>
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">SMART :</span>
						<span :class="site.is_smart ? 'text-success' : 'text-danger'">
						{{ isActive(site.is_smart) }}
					</span>
				</div>
			</div>
			<div class="md-layout mt-4">
				<div class="md-layout-item md-size-50">
					<div class="md-layout">
						<div class="md-layout-item md-size-100">
							<span class="font-bold">Adresse :</span>
							{{ address.addresses }}
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-size-100">
							<span class="font-bold">Code Postal :</span>
							{{ address.zip_code }}
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-size-100s">
							<span class="font-bold">Ville :</span>
							{{ address.city }}
						</div>
					</div>
				</div>
				<div class="md-layout-item md-size-50">
					<div class="md-layout">
						<div class="md-layout-item md-size-100">
							<span class="font-bold">Latitude :</span>
							{{ address.geo_lat }}
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-size-100">
							<span class="font-bold">Longitude :</span>
							{{ address.geo_long }}
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-size-100">
							<span class="font-bold">Visualiser la localisation : </span>
							<a v-if="address.geo_lat !== 'Ø' && address.geo_long !== 'Ø'" class="text-info cursor-pointer"
							   :href="'https://www.google.fr/maps/place/' + address.geo_lat + ',' + address.geo_long" target="_blank">Voir</a>
							<span v-else>Indisponible</span>
						</div>
					</div>
				</div>
			</div>
			<div class="md-layout mt-4">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Horaires d'intervention :</span>
					<template v-if="schedules.length > 0">
						<site-schedules :schedules="schedules"></site-schedules>
					</template>
					<span v-else class="ml-1">Ø</span>
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Horaires - Informations complémentaires :</span>
					<p v-if="site.schedule_comment" class="mb-0">{{ site.schedule_comment }}</p>
					<span v-else class="ml-1">Ø</span>
				</div>
			</div>
			<div class="md-layout mt-4">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Activité :</span>
					{{ activity.name }}
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Secteur :</span>
					{{ sector.name }}
				</div>
			</div>
			<div class="md-layout mt-4">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Technicien attitré :</span>
					{{ technician(1) }}
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">2<sup>ème</sup> Technicien :</span>
					{{ technician(2) }}
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">3<sup>ème</sup> Technicien :</span>
					{{ technician(3) }}
				</div>
			</div>
			<div class="md-layout mt-4">
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Date création :</span>
					{{ site.creation }}
				</div>
				<div class="md-layout-item md-size-50">
					<span class="font-bold">Date modification :</span>
					{{ site.modification }}
				</div>
			</div>
		</md-card-content>
		<md-card-actions v-if="site.is_archived">
			<div class="block-alert danger">
				<p class="font-medium">Le site est archivé ! Il n'est donc pas disponible dans la barre de recherche.</p>
			</div>
		</md-card-actions>
	</div>
</template>

<script>
import SiteSchedules from "@/pages/Sites/Informations/components/SiteSchedules";
export default {
	name: "Informations",
    components: {
	    SiteSchedules
    },
	props: {
		site: Object
	},
	methods: {
		isActive(state) {
			return state ? 'Oui' : 'Non'
		},
        dayOfWeek(dayNumber) {
		    let weekdays = this.$moment.weekdays(true)
		    return weekdays[dayNumber].charAt(0).toUpperCase() + weekdays[dayNumber].slice(1)
        },
        technician(order) {
		    let tech = this.site.technicians?.find(technician => technician.pivot.order === order)
            return tech ? tech.full_name : 'Ø'
        },
	},
	computed: {
		schedules() {
			return this.site.schedules ?? []
		},
		address() {
			return {
				addresses: this.site.address?.addresses ?? 'Ø',
				zip_code: this.site.address?.zip_code ?? 'Ø',
				city: this.site.address?.city ?? 'Ø',
				geo_lat: this.site.address?.geo_lat ?? 'Ø',
				geo_long: this.site.address?.geo_long ?? 'Ø',
			}
		},
		activity() {
			return {
				name: this.site.activity?.name ?? 'Ø'
			}
		},
		sector() {
			return {
				name: this.site.sector?.name ?? 'Ø'
			}
		},
	}
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-icon-button {
        margin: 0;
        padding: 5px;
        height: 27px;
        min-width: 35px;
        width: auto;
        line-height: 27px;
        .md-icon {
            font-size: 0.875rem !important;
            min-width: 0.875rem !important;
            height: 0.875rem !important;
        }
    }

    #schedules.md-list {
        .md-list-item {
            margin-bottom: .15rem;
            margin-left: 0;

            .md-list-item-content {
                font-size: 14px;
                min-height: 18px;
                padding: 0;

                * {
                    width: unset;
                }

                .day {
                    font-weight: 500;
                }
            }
        }
    }
}
</style>
